export const trackInitiateCheckout = _ref => {
  var _expressModel$lineIte;
  let {
    expressModel
  } = _ref;
  const productsInfo = (_expressModel$lineIte = expressModel.lineItems) == null ? void 0 : _expressModel$lineIte.map(item => {
    var _item$catalogReferenc, _item$totalPrice;
    return {
      id: (_item$catalogReferenc = item.catalogReference) == null ? void 0 : _item$catalogReferenc.catalogItemId,
      name: item.name,
      category: 'All Products',
      price: (_item$totalPrice = item.totalPrice) == null ? void 0 : _item$totalPrice.amount,
      currency: expressModel.currency,
      quantity: item == null ? void 0 : item.confirmedQuantity
    };
  });
  return ['InitiateCheckout', {
    contents: productsInfo,
    origin: 'Stores'
  }];
};
//# sourceMappingURL=analytics.utils.js.map